var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.34 2H7.67C4.28 2 2 4.38 2 7.92V16.09C2 19.62 4.28 22 7.67 22H16.34C19.73 22 22 19.62 22 16.09V7.92C22 4.38 19.73 2 16.34 2Z",
    fill: "url(#paint0_linear_2259_101833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1995C12.1314 16.1995 12.2614 16.2229 12.3828 16.2681C12.5041 16.3134 12.6144 16.3798 12.7072 16.4634C12.8001 16.547 12.8738 16.6463 12.924 16.7555C12.9742 16.8647 13 16.9818 13 17.1C13 17.2183 12.974 17.3353 12.9237 17.4445C12.8734 17.5537 12.7997 17.653 12.7068 17.7365C12.6139 17.8201 12.5036 17.8864 12.3822 17.9316C12.2608 17.9768 12.1307 18 11.9993 18C11.734 17.9999 11.4796 17.905 11.2921 17.7361C11.1046 17.5672 10.9992 17.3382 10.9993 17.0994C10.9994 16.8607 11.1049 16.6317 11.2926 16.463C11.4802 16.2942 11.7347 16.1994 12 16.1995ZM12 6C13.0609 6 14.0783 6.37927 14.8284 7.05436C15.5786 7.72946 16 8.64509 16 9.59982C16 10.8988 15.498 11.5737 14.2173 12.5535C12.9327 13.5356 12.6667 13.9778 12.6667 14.9996H11.3333C11.3333 13.5152 11.858 12.7827 13.354 11.6391C14.3653 10.8658 14.6667 10.4602 14.6667 9.59982C14.6667 8.27389 13.4733 7.19994 12 7.19994C10.5267 7.19994 9.33333 8.27389 9.33333 9.59982V10.1998H8V9.59982C8 8.64509 8.42143 7.72946 9.17157 7.05436C9.92172 6.37927 10.9391 6 12 6Z",
    fill: "url(#paint1_linear_2259_101833)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2259_101833",
    x1: 20.4375,
    y1: 18.875,
    x2: 4.1875,
    y2: 4.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2259_101833",
    x1: 15.375,
    y1: 16.125,
    x2: 6.846,
    y2: 11.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.3bd9fb1909927dc4cf47f15051eb7103.svg";
export { ForwardRef as ReactComponent };